import React from "react";
import * as Styled from "./styles";
import ListStatusBar from "../../layout/ListStatusBar";
import ProductPanel from "../ProductPanel";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { onModal } from "../../../stores/modals";
import { useTranslation } from "react-i18next";

interface GridViewProps {
  data: any[];
  cat?: any;
  update?: any;
  sales?: boolean;
}

const GridView = ({ data, cat, sales }: GridViewProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const buyProduct = (e: any) => {
    history.push(`${history.location.pathname}/${e.id}`);
  };

  return (
    <div>
      <ListStatusBar
        leftbody={cat.name ? cat.name : t("extra.all")}
        rightbody={`${t("extra.total")} ${data?.length} `}
      />
      <Styled.GridList>
        {data?.map((e: any, index: number) => (
          <React.Fragment key={index}>
            <ProductPanel
              data={e}
              category={e.ProductCategory}
              onClick={() => {
                if (sales) {
                  buyProduct(e);
                } else {
                  dispatch(onModal("productAdd", { edit: e }));
                }
              }}
            />
          </React.Fragment>
        ))}
        <Styled.Placeholder />
        <Styled.Placeholder />
        <Styled.Placeholder />
        <Styled.Placeholder />
        <Styled.Placeholder />
        <Styled.Placeholder />
        <Styled.Placeholder />
        <Styled.Placeholder />
        <Styled.Placeholder />
        <Styled.Placeholder />
      </Styled.GridList>
    </div>
  );
};

export default GridView;
